module.exports = __webpack_public_path__ + "static/media/parallax.6eaeac81.jpg";